import { LanguageTagTranslation } from '../types';

export const esAR: LanguageTagTranslation = {
  exportOrder: {
    whatEmailExport: '¿A cuál correo querés que le exportemos los datos?',
  },
  employees: {
    selectALocation: 'Seleccioná una Ubicación',
  },
  invoice: {
    recordAPaymentFor: 'Registrá un pago para',
    depositInvalid: 'Ingresá un depósito entre $0.50 y el total de la factura.',
    eventDateRequired: 'Agregá la fecha del evento para que el cliente sepa cuándo vence el saldo.',

    sendPayableInvoice:
      'Para enviar la factura a tu cliente, enviales este enlace por mensaje de texto o correo electrónico:',
  },
  order: {
    refund: {
      canRefundUpTo: 'Podés reembolsar hasta: %{total}',
    },
  },
  salesSummary: {
    salesSummary: 'Resumen de ventas',
    overview: {
      usingCashDescription:
        'Esto es todo lo recaudado pagado por el cliente usando efectivo. Incluye ventas de productos, impuestos y ventas de tarjetas de regalo. Esto no incluye propinas en efectivo ya que no son ingresadas al sistema. Este monto no se pagará porque ya tenés el efectivo en mano.',
      salesTaxWithheldDescription:
        'Si elegís que Avocado retenga el impuesto de ventas, "Impuesto de Venta Retenido" representará la cantidad retenida. Si no elegís que retengamos tus impuestos, la cantidad será cero.',
      grossSalesDescription:
        'Ventas sin descuentos ni reembolsos aplicados. Esto incluye ventas con tarjetas de crédito, efectivo y tarjetas de regalo (ventas donde el cliente usa una tarjeta de regalo para pagar, pero no cuando vendés una tarjeta de regalo). Las Ventas Brutas no incluyen impuestos de venta o propina. Las Ventas Brutas incluyen recargos.',
      fromMerchant: '(Tuyas)',
    },
  },
  payouts: {
    estimatedArrival: 'Los pagos generalmente se realizan al cierre de tu jornada.',
  },
  aiAssistant: {
    placeholder: 'Enviá un mensaje a Avocado AI',
    notepadPlaceholder: 'Tanto la IA como vos pueden escribir aquí...',
    welcomeMessage:
      '¡Hola%{firstName}! Soy una IA que ayuda en la administración de tu restaurante. Podés hablar conmigo como lo harías con ChatGPT, pero yo ya conozco de tu negocio e incluso puedo *hacer cosas* como actualizar tu menú.',
    imageEdited: 'Acá está la imagen editada',
    menuReloadedAfterNotFound:
      'Algunos cambios no se guardaron porque esos elementos del menú ya no están en el servidor. Se recargó el menú y muestra lo que sí se guardó. Revisalo antes de hacer los cambios que faltan.',
  },
  settings: {
    stripe: {
      defaultDisplayName: 'tu negocio',
      description: 'Modificá tu información de negocio y administra cuentas bancarias.',
      requirementsDue:
        'Necesitamos información adicional sobre %{displayName} para continuar mandando pagos. Por favor proporcioná esta información lo antes posible.',
      onboardingSuccess: 'Tu cuenta para %{displayName} está activa y lista para recibir pagos.',
      noAccounts: 'No tenés acceso para administrar cuentas externas.',
      accountsLoadFailed: 'No pudimos cargar tus cuentas. Revisá tu conexión e intentá de nuevo.',
    },
    restaurantSettings: {
      taglinePlaceholder: 'Describí tu restaurante en pocas palabras',
      incompleteOpeningPeriods: 'Por favor, completá todos los horarios de apertura',
      noStripeAccount1: 'Por favor, contactá a ',
    },
  },
};
